<template>
  <ListaItems />
</template>

<script>
import ListaItems from '@/components/Inventario/Lista_items.vue'
export default {
  name: 'InventarioView',
  components: { ListaItems }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/InventarioView.vue